import RequiredSign from "@components/common/ui-elements/required-sign";
import React from "react";
import {isPlainObject} from "@utils/object";

import {generateIdFromName, isNotStringOrEmptyString} from "@utils/string";
import ButtonGroup from "../../form-controls/button-group";
import {isDetailsMode, isEditableMode, isEditMode, useFormMode} from "@contexts/FormModeContext";

export default function ScrollableButtonGroupBlock(
   {
      containerCssClass = 'col-12 py-3',
      dataBlock = '',
      required = false,
      options = [],
      selectedValues = [],
      onChange,
      helpText = '',
      controlId = '',
      controlName = '',
      controlAttrs = {},
      labelText = 'Control Label',
      btnGroupAttrs = {}
   }
) {
   
   const {mode} = useFormMode();
   
   let selectedValuesFormatted = '';
   
   if(isDetailsMode(mode)) {
      
      if(Array.isArray(selectedValues)) {
         selectedValuesFormatted = selectedValues.join(', ');
      } else if(isPlainObject(selectedValues)) {
         selectedValuesFormatted = '-';
      } else {
         selectedValuesFormatted = selectedValues;
      }
      
      if(!selectedValuesFormatted) {
         selectedValuesFormatted = '-';
      }
      
   }
   
   let paramError = '';
   
   
   // region [Additional Css Class]
   
   if (typeof containerCssClass === 'string') {
      containerCssClass += ' scrollable';
   } else if (Array.isArray(containerCssClass)) {
      
      containerCssClass = (containerCssClass.join(' ')) + ' scrollable';
      
   } else {
      containerCssClass = 'scrollable';
   }
   
   if(isDetailsMode(mode)) {
      containerCssClass += ' details-mode';
   }
   
   // endregion
   
   // region [Control Name]
   
   if (typeof controlName !== 'string') {
      
      paramError = ("Control name for dropdown must be a string data type");
      
   } else if (controlName.trim() === '') {
      paramError = ("Control name for dropdown cannot be empty");
   }
   
   controlAttrs.name = controlName;
   
   // endregion
   
   // region [Control Attrs]
   
   if (!isPlainObject(controlAttrs)) {
      controlAttrs = {};
   }
   
   delete controlAttrs.name;
   
   // endregion
   
   // region [Label Text]
   
   if (typeof labelText !== 'string') {
      labelText = '';
   } else {
      labelText = labelText.trim();
   }
   
   // endregion
   
   // region [Data Block]
   
   if (typeof dataBlock !== 'string' || dataBlock.trim() === '') {
      dataBlock = controlName;
   }
   
   // endregion
   
   // region [Control ID]
   
   if (typeof controlId !== 'string' || controlId.trim() === '') {
      controlId = generateIdFromName(controlName);
   }
   
   // endregion
   
   
   return (
      <div className={containerCssClass} data-block={dataBlock}>
         {labelText !== '' && (
            <label
               htmlFor={controlId}
               className="form-label">
               {labelText} <RequiredSign required={required} />
            </label>
         )}
         
         {isEditableMode(mode) && (
            <>
               {paramError !== '' && (
                  <p className="text-danger">{paramError}</p>
               )}
               
               {paramError === '' && (
                  
                  <div>
                     <ButtonGroup
                        idPrefix={controlId + '-'}
                        name={controlName}
                        options={options}
                        selectedValue={selectedValues}
                        onChange={onChange}
                        btnGroupAttrs={btnGroupAttrs}
                     />
                  </div>
               
               )}
               
               
               {helpText !== '' && (
                  <div className="form-text mt-2">
                     {helpText}
                  </div>
               )}
            </>
         )}
         
         {isDetailsMode(mode) && (
            <>
               <div className="form-text">
                  {selectedValuesFormatted}
               </div>
            </>
         )}
         
         
         
         {isEditableMode(mode) && process.env.NEXT_PUBLIC_DISPLAY_CONTROL_NAMES === "1" && (
            <div className="mt-3 d-flex flex-column gap-3" style={{width: 'fit-content'}}>
               
               <p className="m-0 p-3 text-danger badge bg-primary-subtle fs-6 text-break">
                  {controlName}
               </p>
               
               <p className="m-0 p-3 text-black badge bg-success-subtle fs-6 text-break">
                  {dataBlock}
               </p>
            
            </div>
         )}
         
         
      
      </div>
   );
   
}